export const environment = {
    production: true,
    jiraUrl: 'https://jira.seur.com',
    ssoUrl: 'https://sso.seur.com/auth',
    ssoRealm: 'SEUR_Apps_Cloud_PRO',
    ssoClientId: 'geddis-frontend',
    linkCSI: "https://calendar.google.com/calendar/embed?src=c_4a1249d3936f777fcb9d7875ac7b53185bf4c01701ec65ab2b52f5b1471ea48e%40group.calendar.google.com&ctz=Europe%2FMadrid",
    linkRFC: "https://calendar.google.com/calendar/embed?src=c_305420285e241ed9c331c755d318dc7c1f8e07b1a7860735bb51f0f9a69cbcbe%40group.calendar.google.com&ctz=Europe%2FMadrid",
    // linkMaintrack: "https://minetrack.apps.ocppre.seur.es/",
    linkGuardias: "https://calendar.google.com/calendar/u/0/embed?src=c_a30ca023d46c87f13bace6f573e1a8baaad78c339a4616fdf72616a8c407a4ed@group.calendar.google.com&ctz=Europe/Madrid",
    apiUrls: [
        { host: 'geddis.seur.com', url: 'https://geddis.seur.com/backend/geddis' },
        { host: 'geddis.pks.seur.app', url: 'https://geddis-backend-pro.pks.seur.app/geddis' },
        { host: 'geddis.seur.app', url: 'https://geddis.seur.app/backend/geddis' }
    ],
    defaultUrl: 'https://geddis.seur.com/backend/geddis'
};
